import styled from 'styled-components';

export const ConteinerMenuLateral = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;

  width: fit-content;
`;

export const Conteiner = styled.div`
  display: flex;
  flex: 1;
`;
